import ValidationServiceDefault from "@/services/_bit/ValidationService";

class ValidationService extends ValidationServiceDefault {
  // You can redefine some part of default class here
}

export default new ValidationService();
